import React from "react";

interface HorizontalRuleProps {
  color?: string;
  height?: number;
  margin?: number;
}

const HorizontalRule: React.FC<HorizontalRuleProps> = ({
  color = "light-dark(#c6c6cd, #424650)",
  height = 1,
  margin = 10,
}) => {
  return (
    <div
      style={{
        borderBottom: `${height}px solid ${color}`,
        margin: `${margin}px 0 ${margin}px 0`,

        width: "100%",
      }}
    />
  );
};

export default HorizontalRule;
